export default {
  pl: {
    contacts: {
      digital_campaigns: { name: "", email: "adhub-pl@bauermediaoutdoor.com" },
      print_campaigns: { name: "", email: "" },
    },
  },
  fi: {
    contacts: {
      digital_campaigns: { name: "", email: "campaigns-fi@bauermediaoutdoor.com" },
      print_campaigns: { name: "", email: "" },
    },
  },
  be: {
    contacts: {
      digital_campaigns: { name: "", email: "content-be@bauermediaoutdoor.com" },
      print_campaigns: { name: "", email: "" },
    },
  },
  nl: {
    contacts: {
      digital_campaigns: { name: "", email: "content-nl@bauermediaoutdoor.com" },
      print_campaigns: { name: "", email: "" },
    },
  },
  se: {
    contacts: {
      digital_campaigns: { name: "", email: "campaignmaterial-se@bauermediaoutdoor.com" },
      print_campaigns: { name: "", email: "" },
    },
  },
  no: {
    contacts: {
      digital_campaigns: { name: "", email: "campaignmanagement-no@bauermediaoutdoor.com" },
      print_campaigns: { name: "", email: "" },
    },
  },
  dk: {
    contacts: {
      digital_campaigns: { name: "", email: "cmmaterial-dk@bauermediaoutdoor.com" },
      print_campaigns: { name: "", email: "" },
    },
  },
};
